import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';

export const EventStarterKeySchema = z.object({
  id: ObjectIdSchema,
  key: z.string().min(6).max(6), // 6 Digits of Letters and numbers
  used: z.boolean(),
  eventId: ObjectIdSchema, // the related event ID
  createdAt: DateSchema,
  updatedAt: DateSchema,
});

export type EventStarterKey = z.infer<typeof EventStarterKeySchema>;

export const EventStarterKeysSchema = z.array(EventStarterKeySchema);

export type EventStarterKeys = z.infer<typeof EventStarterKeysSchema>;
